import { TextInput, DateInput } from '@octano/global-ui';
import { Col, Row } from 'reactstrap';

export interface SummaryPetitionProps {
  petitionTitle: string;
  petitionType: string;
  studyPlan: string;
  petitionDate: string;
  evaluationDate: string | undefined;
  section: { id: number; name: string } | undefined;
  paymentAmount?: string | number;
  texts: {
    petitionTitle: string;
    petitionType: string;
    studyPlan: string;
    createdAt: string;
    evaluationDate: string;
    sectionName: string;
    payment: string;
    period: string;
    phone: string;
    email: string;
    contractedCredits: string;
    enrolledCredits: string;
    availableCredits: string;
    creditsToFreeze: string;
    recommendedCredits: string;
    requestedCredits: string;
    targetProgram: string;
  };
  freezePetitionData?: {
    contractedCredits: number;
    creditsToFreeze: number;
    enrolledCredits: number;
    maxCreditsToFreeze: number;
    freezeSemester: boolean;
    period: { name: string };
  };
  creditReliquidationData?: {
    recommendedCredits: number;
    creditsToEnroll: number;
    period: { name: string };
  };
  reintegroData?: {
    targetStudyPlanEnrollmentId: number;
    programName?: string | null;
  };
  contact: {
    phone?: string;
    mail?: string;
  };
}

export default function StudentPetitionSummary({
  texts,
  ...data
}: SummaryPetitionProps) {
  return (
    <>
      <Row>
        <Col xs={12} sm={6} md={4} xl="">
          <TextInput
            name="petitionTitle"
            label={texts.petitionTitle}
            value={data.petitionTitle}
            disabled
          />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <TextInput
            name="petitionType"
            label={texts.petitionType}
            value={data.petitionType}
            disabled
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl="">
          <TextInput
            name="studyPlan"
            label={texts.studyPlan}
            value={data.studyPlan}
            disabled
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={4}>
          <DateInput
            name="createdAt"
            label={texts.createdAt}
            value={data.petitionDate}
            disabled
          />
        </Col>
        {data.evaluationDate && (
          <Col xs={12} sm={6} md={4}>
            <DateInput
              name="evaluationDate"
              label={texts.evaluationDate}
              value={data.evaluationDate}
              disabled
            />
          </Col>
        )}
        {data.section && (
          <Col xs={12} sm={6} md={4}>
            <TextInput
              name="section"
              label={texts.sectionName}
              value={data.section.name}
              disabled
            />
          </Col>
        )}

        {data.freezePetitionData && (
          <>
            <Col sm={6} md={4}>
              <TextInput
                name="period"
                label={texts.period}
                value={data.freezePetitionData.period.name}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="phone"
                label={texts.phone}
                value={data.contact.phone}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="email"
                label={texts.email}
                value={data.contact.mail}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="contractedCredits"
                label={texts.contractedCredits}
                value={data.freezePetitionData.contractedCredits}
                formatter={(value) => value.toString()}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="enrolledCredits"
                label={texts.enrolledCredits}
                value={data.freezePetitionData.enrolledCredits}
                formatter={(value) => value.toString()}
                disabled
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="availableCredits"
                label={texts.availableCredits}
                value={data.freezePetitionData.maxCreditsToFreeze}
                formatter={(value) => value.toString()}
                disabled
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="creditsToFreeze"
                label={texts.creditsToFreeze}
                value={data.freezePetitionData.creditsToFreeze}
                formatter={(value) => value.toString()}
                disabled={true}
              />
            </Col>
          </>
        )}

        {data.creditReliquidationData && (
          <>
            <Col sm={6} md={4}>
              <TextInput
                name="period"
                label={texts.period}
                value={data.creditReliquidationData.period?.name || '-'}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="recommendedCredits"
                label={texts.recommendedCredits}
                value={data.creditReliquidationData.recommendedCredits}
                formatter={(value) => value.toString()}
                disabled={true}
              />
            </Col>
            <Col sm={6} md={4}>
              <TextInput
                name="requestedCredits"
                label={texts.requestedCredits}
                value={data.creditReliquidationData.creditsToEnroll}
                formatter={(value) => value.toString()}
                disabled={true}
              />
            </Col>
          </>
        )}

        {data.reintegroData?.programName && (
          <Col xs={12} sm={6} md={4}>
            <TextInput
              name="targetProgram"
              label={texts.targetProgram}
              value={data.reintegroData.programName}
              disabled
            />
          </Col>
        )}
      </Row>
    </>
  );
}
